import { useRef, useEffect } from 'react'
import type { MutableRefObject } from 'react'

/**
 * a type-safe version of the `usePrevious` hook described here:
 * @see {@link https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state}
 * @source: https://gist.github.com/btoo/65e7d4303f49299c785d38f8758525e6
 */
export function usePrevious<T> (
  value: T
): MutableRefObject<T | undefined>['current'] {
  const ref = useRef<T>()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}
